import React, { useEffect, useState } from 'react';
import translate from '../portfolio';
import {
  BlogHeader, BlogGrid, BlogPost, BlogError,
} from './Blog.styles';
import { Post, type PostProps } from './Post';
import { fetchLatestPosts, isAbortError } from './helpers';

export const Blog = () => {
  const [post, setPost] = useState<PostProps[]>([]);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const controller = new AbortController();

    const loadPosts = async () => {
      try {
        const posts = await fetchLatestPosts(controller.signal);

        if (controller.signal.aborted) {
          return;
        }

        setPost(posts);
        setHasError(false);
      } catch (error) {
        if (isAbortError(error)) {
          return;
        }

        setPost([]);
        setHasError(true);
      }
    }

    loadPosts();

    return () => {
      controller.abort();
    };
  }, []);

  if (hasError) {
    return (
      <BlogGrid>
        <BlogHeader>{translate.blogTitle}</BlogHeader>
        <BlogError role="alert">Unable to load recent articles.</BlogError>
      </BlogGrid>
    )
  }

  return (
    <BlogGrid>
      <BlogHeader>{translate.blogTitle}</BlogHeader>
      <BlogPost>
        {post.slice(0, 3).map((post) => (
          <Post key={post.url} {...post} />
        ))}
      </BlogPost>

      <div aria-live='polite'>
        {hasError &&
          <BlogError role="alert">Unable to load recent articles.</BlogError>}
      </div>
    </BlogGrid>
  );
}
